import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FleetManagementRoutingModule } from './fleet-management-routing.module';

import { DataTableModule } from '@pascalhonegger/ng-datatable';

import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CardModule } from 'primeng/card';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

import { TariffComponent } from './components/tariff/tariff.component';
import { AddUserComponent } from './components/users/add-user/add-user.component';
import { AnonymousUsersComponent } from './components/users/anonymous-users/anonymous-users.component';
import { EditUserComponent } from './components/users/edit-user/edit-user.component';
import { UsersListComponent } from './components/users/users-list/users-list.component';
import { AddVehicleComponent } from './components/vehicles/add-vehicle/add-vehicle.component';
import { VehiclesListComponent } from './components/vehicles/vehicles-list/vehicles-list.component';
import { ConsumptionCeilingComponent } from './components/consumption-ceiling/consumption-ceiling.component';

import { NbImplementationModule } from '../nb-implementation.module';
import { GrdFilterPipe } from 'src/app/shared/constants/grd-filter.pipe';
import { MaskTextPipe } from 'src/app/shared/pipe/NameEmailHide.pipe';


@NgModule({
  declarations: [
    VehiclesListComponent,
    AddVehicleComponent,
    UsersListComponent,
    EditUserComponent,
    AnonymousUsersComponent,
    AddUserComponent,
    TariffComponent,
    ConsumptionCeilingComponent,
    GrdFilterPipe,
    MaskTextPipe,
  ],
  imports: [
    CommonModule,
    FleetManagementRoutingModule,
    SharedModule,
    TranslateModule,
    PanelModule,
    TooltipModule,
    InputTextModule,
    InputNumberModule,
    InputTextareaModule,
    ButtonModule,
    DropdownModule,
    CalendarModule,
    RadioButtonModule,
    DialogModule,
    CardModule,
    DataTableModule,
    NbImplementationModule
  ],
})
export class FleetManagementModule { }
